<template>
<div>
  <v-layout fill-height="" column="" style="position:relative;background-color:#1e1e1e;height:690px" v-if="!$vuetify.breakpoint.smAndDown">
    <v-card v-if="isGalleryView" height="690px" style="overflow-y: auto;" flat color="#1e1e1e">
        <v-container fluid class="height:100px pt-0 pb-0">
          <v-layout column :style="(isMultiple) ? 'padding-left: 70px;' : 'padding-left: 40px;'">
            <h1 style="color:white;font-size:32px">
              {{asset.name}}
            </h1>
            <span style="color:white;font-size:16px">{{copyrightText}}</span>
          </v-layout>
          <v-row style="max-height:600px;overflow-y: auto;" class="pr-4">
            <v-col
            v-for="(resource,i) in filteredResources" :key="i"
            class="d-flex child-flex pa-1"
            cols="2"
            >
            <v-card flat tile hover="" @click="OnClickGalleryImage(i)" color="transparent">
              <v-img
                :src="resource.url"
                aspect-ratio="1"
                class="grey lighten-2"
                :position="GetPositionForImage(resource)"
              >
              </v-img>
            </v-card>
            </v-col>
          </v-row>
      </v-container>
      <v-card style="position:absolute;bottom:0px;" color="rgba(0,0,0,0.1)">
        
      </v-card>
    </v-card>
    <v-carousel
    v-else
    v-model="activeResource"
      
      height="770px"
      show-arrows-on-hover
      hide-delimiters=""
      :show-arrows="filteredResources.length > 1"
    >
    
      <v-carousel-item
        v-for="(resource, i) in filteredResources"
        :key="i"
      >
      <v-layout class="pa-4" height="570px" align-center justify-center>
        <v-flex shrink>
          <div style="">
            <img 
            :transition="false"
            :eager="false"
            :style="(resources.length == 1) ? 'object-fit: contain;max-height:664px' :  'object-fit: contain;max-height:570px'"  width="100%"  :src="resource.url">
          </div>
        </v-flex>
        <v-flex shrink class="pa-2 ml-4" v-if="GetSubtitleForResource(resource) != ''">
          <v-card class width="240px" height="200px" color="transparent">
            <div v-if="typeData.useIcons" style="">
              <v-img :src="'https://activstoredev.blob.core.windows.net/test/WA/Flags/ExampleFlag.png'" height="80px" width="40px" contain/>
            </div>
            <div style="border-top: 2px solid white;width:100%;height:2px" class="mb-4"  />
            <span class="headline pr-1" style="font-family:waHeadline !important;" >{{GetSubtitleForResource(resource)}}</span>
            <div style="border-bottom: 2px solid white;width:100%;height:2px" class="mt-4"  />
          </v-card>
        </v-flex>
      </v-layout>
        
      
      </v-carousel-item>
    </v-carousel>
    <v-card v-if="!isGalleryView && filteredResources.length > 1" ref="imageSelector" style="z-index:10;position:absolute;right:0%;left:0%;bottom:0%;" class="mt-2" height="76px" color="transparent" flat>
      <v-slide-group
        v-model="activeResource"
        center-active
        show-arrows
        mandatory
        dark
      >
        <v-slide-item
          v-for="(resource, i) in filteredResources"
          :key="i"
          v-slot:default="{ active, toggle }"
        >
          <v-card
            :color="active ? 'primary' : 'grey lighten-1'"
            height="76"
            width="76"
            class="mr-1"
            @click="toggle"
            style="border-radius:0px"
          >
            <v-img
            height="100%"
            :src="resource.url"
            :position="GetPositionForImage(resource)"
            >

            </v-img>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-card> 

    <v-btn v-if="allowGalleryView && !isGalleryView" @click="isGalleryView=true" dark floating right top fab style="position:absolute;" small="" class="ma-2" color="rgba(0,0,0,0.6)">
      <v-icon>
        mdi-table-large
      </v-icon>
    </v-btn>
    <!--
    <v-card flat="" color="rgba(0,0,0,0.45)" v-if="hasDescription && !isGalleryView" class="pa-4" style="position:absolute;bottom:0;right:0;left:0">
      <span style="color:white">{{resources[activeResource].description}}</span>
    </v-card>
    -->
  </v-layout>
  <v-layout  column="" style="position:fixed;bottom:48px;top:0px;left:0px;right:0px;background-color:#1e1e1e;" v-else>
    <v-card v-if="isGalleryView" height="100%" style="overflow-y: auto;" flat color="#1e1e1e" class="pt-2">
        <v-container fluid class="height:100px pt-0 pb-0">
            <h1 style="color:white;font-size:32px">
                {{asset.name}}
            </h1>
            <span style="color:white;font-size:16px">{{copyrightText}}</span>
          <v-row style="max-height:100%;overflow-y: auto;">
            <v-col
            v-for="(resource,i) in filteredResources" :key="i"
            class="d-flex child-flex pa-1"
            cols="4"
            sm="2"
            >
            <v-card flat tile hover="" @click="OnClickGalleryImage(i)" color="transparent">
              <v-img
                :src="(resource.thmurl != null) ? resource.thmurl : resource.url"
                aspect-ratio="1"
                class="grey lighten-2"
                :position="GetPositionForImage(resource)"
              >
              </v-img>
            </v-card>
            </v-col>
            <v-col cols="12">
            <div style="height:80px;width:60px"/>
            </v-col>
          </v-row>
      </v-container>
    </v-card>
    <v-card v-else height="100%" color="#1e1e1e" class="pa-4">
      <v-card height="100%" width="100%" color="transparent" flat>
        <v-layout fill-height column>
          <div style="flex-grow:1;">
            <v-card style="top:0px;bottom:100px;left:0px;right:0px;position:absolute;"  color="transparent" flat>
              <v-carousel
                v-model="activeResource"
                height="100%"
                show-arrows-on-hover
                hide-delimiters=""
              >
              
                <v-carousel-item
                  v-for="(resource, i) in filteredResources"
                  :key="i"
                >
                  <v-img 
                  :transition="false"
                  :eager="false"
                  contain height="100%"  :src="resource.url" style="position:absolute;"/>
                </v-carousel-item>

              </v-carousel>
            </v-card>
          </div>
          <div style="height:100px;">
            <v-card height="100px" color="transparent" dark class="pt-4">
              <div v-if="typeData.useIcons" style="">
                <v-img :src="'https://activstoredev.blob.core.windows.net/test/WA/Flags/ExampleFlag.png'" height="80px" width="40px" contain/>
              </div>
              <div style="border-top: 2px solid white;width:100%;height:2px" class="mb-1"  />
              <span class="subtitle-1 pr-1" style="font-family:waHeadline !important;" > {{GetSubtitleForResource(activeResourceObject)}}</span>
              <div style="border-bottom: 2px solid white;width:100%;height:2px" class="mt-1"  />
           </v-card>
          </div>

          
          <!--
          <v-flex style="background-color:orange;position:static;" >
            <v-card color="red" height="100%" width="400px" style="position:relative;" flat >
            
                
              <v-carousel
                v-model="activeResource"
                height="100%"
                show-arrows-on-hover
                hide-delimiters=""
              >
              
                <v-carousel-item
                  v-for="(resource, i) in filteredResources"
                  :key="i"
                >
                  <v-img 
                  :transition="false"
                  :eager="false"
                  contain height="100%"  :src="resource.url" style="position:absolute;"/>
                </v-carousel-item>

              </v-carousel>
              
  
            </v-card>
          </v-flex>
          <v-flex shrink class>
            
            
          </v-flex>
          -->
        </v-layout>
      </v-card>
    </v-card>
    <!--
    <v-carousel
      v-model="activeResource"
      show-arrows-on-hover
      hide-delimiters=""
    >
      <v-carousel-item
        v-for="(resource, i) in filteredResources"
        :key="i"
        :transition="''"
        to="''"
      >
      <v-layout class="pa-4" align-center justify-center column>
        <v-flex shrink>
          <img style="object-fit: contain;" height="400px"  :src="resource.url">
        </v-flex>
        <v-flex shrink>
          <v-card color="blue" width="100vw" height="140px"/>
        </v-flex>
      </v-layout>
        
      
      </v-carousel-item>
    </v-carousel>
    -->
 
    <v-btn v-if="allowGalleryView && !isGalleryView" @click="isGalleryView=true" dark floating right top fab style="position:absolute;" small="" class="ma-2" color="rgba(0,0,0,0.6)">
      <v-icon>
        mdi-table-large
      </v-icon>
    </v-btn>
    <!--
    <v-card flat="" color="rgba(0,0,0,0.45)" v-if="hasDescription && !isGalleryView" class="pa-4" style="position:absolute;bottom:0;right:0;left:0">
      <span style="color:white">{{resources[activeResource].description}}</span>
    </v-card>
    -->
  </v-layout>
</div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';
  export default {
    name: 'ImageResourcesView',
    components: {
    },
    props: {

      asset : {},
      resources : Array,
      typeData : null,
      icons : Array,
      isMultiple : true
    },
    computed: {

      activeResourceObject()
      {
        return this.filteredResources[this.activeResource];
      },
      filteredResources()
      {
        var filteredResources = this.resources.filter(e => !e.tags.includes('logo') && !e.tags.includes('NoGallery'));
        return filteredResources;
      },
      hasDescription()
      {
        return (this.resources[this.activeResource].description != null && this.resources[this.activeResource].description.length > 0)
      },
      copyrightText()
      {
        if(this.typeData.pictureCreditsText != null && this.typeData.pictureCreditsText != "")
        {
          return this.typeData.pictureCreditsText;
        }
        else
        {
          return "Photographs: © Getty Images";
        }
      }

    },

    mounted () {

      if(this.filteredResources.length == 1)
      {
        this.isGalleryView = false;
      }
      else
      {
        this.isGalleryView = true;
      }


    },
    data: () => ({

      isGalleryView : false,
      allowGalleryView : false,
      activeResource : 0,
      cursorInsideGallery : false

    }),
    methods: {

      GetSubtitleForResource(resource)
      {
        if(resource.description == null || resource.description == "")
        {
          let name = resource.name.substring(0,resource.name.length -4);
          name = name.replace(/-/g,' ');
          return name;
        }
        else
          return resource.description;
      },
      GetIconForResource(resource)
      {
        for (let index = 0; resource.tags.length; index++) {
          
          var matchingIcon = this.icons.filter(e => e.tag == resource.tags[index]);

          if(matchingIcon.length > 0)
          {
            return matchingIcon[0].url;
          }
        }

        return null;
      },
      NameWithoutExtension(name)
      {
        var splitString = name.split('.');
        return splitString[0];
      },
      OnClickGalleryImage(index)
      {
        this.activeResource = index;
        this.isGalleryView = false;
      },
      GetPositionForImage(imgResource)
      {
        if(imgResource.tags.some(t => t.includes("crop-left")))
        {
          return "left";
        }
        else if (imgResource.tags.some(t => t.includes("crop-top")))
        {
          return "top";
        }
        else if (imgResource.tags.some(t => t.includes("crop-right")))
        {
          return "right";
        }
        else if (imgResource.tags.some(t => t.includes("crop-bottom")))
        {
          return "bottom";
        }
        else if (imgResource.tags.some(t => t.includes("crop-center")))
        {
          return "center";
        }
        else
        {
          return "top";
        }
      }
    },
    watch: {

      
      typeData : {

        immediate : true,
        handler(newVal)
        {
          if(newVal != null)
          {
            this.isGalleryView = newVal.showGallery;
            this.allowGalleryView = newVal.showGallery;
          }
        }
      },
      cursorInsideGallery : {

        handler(isInsideGallery)
        {
          if(isInsideGallery)
          {
            anime({
              targets: this.$refs.imageSelector.$el,
              opacity: 0.9,
              duration: 300,
              easing: 'linear'
            });
          }
          else
          {
            anime({
              targets: this.$refs.imageSelector.$el,
              opacity: 0.2,
              duration: 300,
              easing: 'linear'
            });
          }
        }
      }
      
    }
  }
</script>
